(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$rootScope', '$scope', '$state', '$timeout', 'Auth', 'Principal', 'User', 'ProfileService', 'LoginService', 'Search', 'Discussion', 'Alert', 'Picture', 'Oauth2LoginService', '$window'];

    function NavbarController ($rootScope, $scope, $state, $timeout, Auth, Principal, User, ProfileService, LoginService, Search, Discussion, Alert, Picture, Oauth2LoginService, $window) {
        var vm = this;


        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.noResults = false;
        vm.query = '';
        vm.$state = $state;
        vm.isLoginModalOpen = false;
        vm.searchCompaniesCount = 0;
        vm.searchCollectivitiesCount = 0;
        vm.searchProfilesCount = 0;

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.search = search;
        vm.markAlertAsSeen = markAlertAsSeen;
        vm.seenFilter = seenFilter;

        vm.discussions = [];
        vm.alerts = [];
        //Discussion.query(onDiscussionsFetchCompleted);
        //Alert.query(onAlertsFetchCompleted);

        vm.myPicture;
        vm.hasProfile = Principal.hasProfile;
        vm.isAdmin = isAdmin;



        vm.currentAccount = null;

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });


        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        $scope.$watch('vm.query', function (query) {
            if (typeof query === 'object') {
                console.log(query);
                if (query.dropdownType === 'profile') {
                    $state.go('profile', { id: query.id })
                } else if (query.dropdownType === 'company') {
                    $state.go('company-detail', { id: query.id })
                } else if (query.dropdownType === 'collectivity') {
                    $state.go('collectivity-detail', { id: query.id })
                }
            }
        });

        Principal.profile().then(function (profile) {
            loadPicture(profile);
        })

        // Prevent inbox pop-up from window scrolling
        $timeout(function () {
            angular.element('#inbox-popup-container').bind('DOMMouseScroll mousewheel', preventScrollPropagation);
            angular.element('#alerts-popup-container').bind('DOMMouseScroll mousewheel', preventScrollPropagation);
        });

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        $rootScope.$on('$stateChangeStart', function() {
            vm.query = '';
        });

        function onAlertsFetchCompleted(alerts) {
            vm.alerts = alerts;
            vm.alerts = vm.alerts.map(buildAlertMessage);
        }

        function buildAlertMessage(alert) {
            switch (alert.type) {
                case 'profile':
                    alert.message = "Le profil de " + alert.profile.firstName + " " +
                        alert.profile.lastName + " a été modifié";
                    if (alert.modification.field === "job") {
                        alert.submessage = "Fonction : " + alert.modification.value;
                    }
                    break;
                case 'organisation':
                    alert.message = "La page de " + alert.organisation.name + " a été modifiée";
                    break;
            }
            return alert;
        }

        function markAlertAsSeen(alert) {
            alert.seen = true;
            Alert.update(alert, function () {
                $state.reload();
            });
        }

        function seenFilter(alert) {
            return alert.seen === false;
        }

        function onDiscussionsFetchCompleted(discussions) {
            var conversations = [];
            // Replace discussion.members by discussion.contact
            Principal.identity().then(function (me) {
                discussions.forEach(function (discussion) {
                    var d = discussion;
                    if (d.admin) {
                        if (me.authorities.indexOf("ROLE_ADMIN") > -1) {
                            d.contact = d.members[0];
                            // Désactivation rgpd
                            /*
                            if (d.contact.pictureContentType){
                                Picture.getProfilePictureByEmail(d.contact.email).then(function (picSrc) {
                                    d.contact.picture = picSrc;
                                });
                            }
                            */
                        } else {
                            d.contact = {
                                id: 0,
                                firstName: "Axenteev",
                                lastName: "",
                                picture: "../content/images/axenteev-icon.svg"
                            }
                        }
                    } else {
                        if (d.members[0].id !== me.id) {
                            d.contact = d.members[0];
                        } else {
                            d.contact = d.members[1];
                        }

                        if (d.contact.pictureContentType){
                            Picture.getProfilePictureByEmail(d.contact.email).then(function (picSrc) {
                                d.contact.picture = picSrc;
                            });
                        }
                    }
                    // Show only open conversations
                    if (!d.closed) {
                        conversations.push(d);
                    }
                });
                if (conversations.length > 5) {
                    conversations = conversations.splice(0, 5);
                }
                vm.discussions = conversations;
            });
        }

        function login() {
            collapseNavbar();
            vm.isLoginModalOpen = true;
            LoginService.open().then(function() {
                vm.isLoginModalOpen = false;
            });
        }

        function logout() {
            collapseNavbar();

            Principal.identity().then(function (me) {
                if (me && me.oauth2) {
                    Oauth2LoginService.logout({}, function(oauth2LogoutResponse) {
                        Auth.logout();
                        $window.location.href = oauth2LogoutResponse.logoutUrl;
                    }, function (err) {
                        Auth.logout();
                        $state.go('home', {}, {reload: true});
                    });
                } else {
                    Auth.logout();
                    $state.go('home', {}, {reload: true});
                }
            });
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function search(q) {
            return Search.query(q).then(reshapeQueryResults);
        }

        function reshapeQueryResults(response) {
            var data = response.data;
            var collectivities = data.collectivities.map(function (el) {
                el.dropdownType = 'collectivity';
                return el;
            });
            var companies = data.companies.map(function (el) {
                el.dropdownType = 'company';
                return el;
            });

            var profiles1 = data.profiles['1'].map(function (el) {

                el.name = el.firstName + ' ' + el.lastName;
                el.dropdownType = 'profile';
                return el;
            });
            var profiles2 = [];
            if ( data.profiles['2']) {
                profiles2 = data.profiles['2'].map(function (el) {
                    el.name = el.firstName + ' ' + el.lastName;
                    el.dropdownType = 'profile';
                    return el;
                });
            }


            var mixedResults = [];
            var maxLen = Math.max(collectivities.length, companies.length, profiles1.length, profiles2.length, 6);
            for (var i = 0; i < maxLen; i++) {
                if (i < collectivities.length) mixedResults.push(collectivities[i]);
                if (i < companies.length) mixedResults.push(companies[i]);
                if (i < profiles1.length) mixedResults.push(profiles1[i]);
                if (i < profiles2.length) mixedResults.push(profiles2[i]);
            }
            return mixedResults.splice(0, 18);
        }

        function preventScrollPropagation(ev) {
            var $this = $(this),
                scrollTop = this.scrollTop,
                scrollHeight = this.scrollHeight,
                height = $this.innerHeight(),
                delta = (ev.type == 'DOMMouseScroll' ?
                ev.originalEvent.detail * -40 :
                    ev.originalEvent.wheelDelta),
                up = delta > 0;

            var prevent = function() {
                ev.stopPropagation();
                ev.preventDefault();
                ev.returnValue = false;
                return false;
            };

            if (!up && -delta > scrollHeight - height - scrollTop) {
                // Scrolling down, but this will take us past the bottom.
                $this.scrollTop(scrollHeight);
                return prevent();
            } else if (up && delta > scrollTop) {
                // Scrolling up, but this will take us past the top.
                $this.scrollTop(0);
                return prevent();
            }
        }

        function loadPicture(profile){
            if (profile && profile.pictureContentType){
                Picture.getProfilePicture(profile.id).then(function (response) {
                    vm.myPicture=response;
                }, function (response) {
                });
            }
        }


    }
})();
